module.exports = __webpack_public_path__ + "img/ranking-top12-m.939b4dc5.png";